<div fxFill>
  <app-today-performance (onChangedPeriod)="periodChanged($event)"></app-today-performance>
</div>
